import { EndpointModulesStatusDetailsView } from '../view/EndpointModulesStatusDetailsView';
import { templateEndpointModules } from '../view/template';
import { EndpointModulesStatusDetailsWebComponent } from '../component/EndpointModulesStatusDetailsWebComponent';
import { BaseWidgetController } from '../../../widget/BaseWidgetController';
import { GetEndpointModuleStatusResponse } from '@nirvana/shared/dtos/types/widgets/common';

export class EndpointModulesStatusDetailsController extends BaseWidgetController<GetEndpointModuleStatusResponse> {
  public component: EndpointModulesStatusDetailsWebComponent;
  public view: EndpointModulesStatusDetailsView;
  public viewConstructor: typeof EndpointModulesStatusDetailsView;

  constructor(component: EndpointModulesStatusDetailsWebComponent) {
    super(component);
    this.initialWidgetSetup({
      viewConstructor: EndpointModulesStatusDetailsView,
      viewTemplate: templateEndpointModules,
      dataFetchMethod: this.component.dependencies.api.clients.Widgets.getEndpointModuleStatus,
    });
  }
}
